import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import request from './utils/request'
import { getUserInfo } from '././utils/user'
Vue.use(Router)

// 系统菜单位置 需要菜单路由验证请添加：meta: { type: 'menu' }
export const systemMenus = {
  path: '/',
  // dynamic:true, // type 为dynamic时，后台系统进行权限验证，
  redirect: '/bjba/home'
  // name: 'layout',
  // meta: { title: '' }
}
const customerMenu = {
    path: '/customer',
    name: 'customer',
    redirect: '/customer/home',
    component: () => import('./views/customer/layout/layout.vue'),
    meta: { type: 'menu' },
    children: [
        {
            path: 'home',
            name: 'customerHome',
            component: () => import('./views/customer/home/home.vue'),
            meta: { type: 'menu' }
        },{
            path:'article/read',
            name:'customerRead',
            component: () => import('./views/customer/article/read.vue'),
            meta: { type: 'menu' },
        },
        {
            path:'feedback',
            name:'feedback',
            component: () => import('./views/customer/feedback/feedback.vue'),
            meta: { type: 'menu' },
        },
        {
            path:'feedbackList',
            name:'feedbackList',
            component: () => import('./views/customer/feedback/feedback-list.vue'),
            meta: { type: 'menu' },
        },
        {
            path:'questionnaire',
            name:'questionnaire',
            component: () => import('./views/customer/questionnaire/questionnaire.vue'),
            meta: { type: 'menu' },
        },
        {
            path:'questionaire/info',
            name:'questionaire_info',
            component: () => import('./views/customer/questionnaire/questionnaire-info.vue'),
            meta: { type: 'menu' },
        },{
            path:'guest/log',
            name:'guest_log',
            component: () => import('./views/customer/guest/guest-list.vue'),
            meta: { type: 'menu' },
        },{
            path:'patrol/log',
            name:'patrol_log',
            component: () => import('./views/customer/patrol/patrol-log-list.vue'),
            meta: { type: 'menu' },
        }
    ],
    beforeEnter:(to:Router,form:Router,next:any) => {
        var token;
        if(!store.getters.token) {
            var info = JSON.parse(sessionStorage.getItem("triman_bsrkapp_store"))

            if(info && info.token) token = info.token
        } else token = store.getters.token
        if (token) {
            if (whiteList.indexOf(to.path) !== -1) {
                // 在免登录白名单，直接进入
                next()
            }
            //是否存在用户信息，没有的话从后端获取
            else if (!store.getters.name) {
                getUserInfo()
                    .then((response: any) => {
                        store.commit('updateUser', response.data)
                        handle()
                    })
                    .catch(error => {
                        store.commit('setToken', '')
                        next('/401')
                        NProgress.done()
                    })
            } else {
                handle()
            }
        } else {
            if (whiteList.indexOf(to.path) !== -1) {
                // 在免登录白名单，直接进入
                next()
            } else {
                next('/login') // 否则全部重定向到登录页
                NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
            }
        }
        //此方法为验证登录成功并获取获取用户信息成功的处理方法
        function handle() {
            if (to.path === '/login') {
                next({ path: '/' })
            } else if (to.path === '/') {
                if (store.getters.user.type === 1) {
                    next('/customer/home')
                    NProgress.done()
                }  else {
                    next('/bjba/home')
                    NProgress.done()
                }
            } else {
                if (store.getters.user.type === 0) {
                    next('/bjba/home')
                    NProgress.done()
                    return
                }
                next()
            }
        }
    }
}
//业务菜单位置 需要菜单路由验证请添加：meta: { type: 'menu' }
const businessMenus = {
  path: '/bjba',
  name: 'bjba',
  redirect: '/bjba/home',
  component: () => import('./views/bjba/layout/layout.vue'),
  meta: { type: 'menu' },
  children: [
    {
      path: 'home',
      name: 'bjbaHome',
      component: () => import('./views/bjba/home/home.vue'),
      meta: { type: 'menu' }
     },
      {
          path: 'map',
          name: 'bjbaMap',
          component: () => import('./views/bjba/map/map.vue'),
          meta: { type: 'menu' }
      },
      {
          path: 'trace/map',
          name: 'tracemap',
          component: () => import('./views/bjba/trace/trace-map.vue'),
          meta: { type: 'menu' }
      },
      {
          path: 'zg',
          name: 'zg',
          component: () => import('./views/bjba/map/zg.vue'),
          meta: { type: 'menu' }
      },
    {
      path:'grzx',
      name:'grzx',
      component: () => import('./views/bjba/grzx/index.vue'),
	  meta: { type: 'menu' },
	},
      {
          path:'grzx_leave',
          name:'grzx_leave',
          component: () => import('./views/bjba/grzx/index-leave.vue'),
          meta: { type: 'menu' },
      },
      {
          path:'article/read',
          name:'read',
          component: () => import('./views/bjba/article/read.vue'),
          meta: { type: 'menu' },
      },
      {
          path:'customer/contractDetail',
          name:'contractDetail',
          component: () => import('./views/bjba/customer/contract-detail.vue'),
          meta: { type: 'menu' },
      },{
          path:'questionaire/answer',
          name:'questionaire_answer',
          component: () => import('./views/bjba/questionnaire/questionnaire-answer.vue'),
          meta: { type: 'menu' },
      },{
          path:'questionaire/tj',
          name:'questionaire_tj',
          component: () => import('./views/bjba/questionnaire/questionnaire-tj.vue'),
          meta: { type: 'menu' },
      },{
          path:'questionaire/prview',
          name:'questionaire_prview',
          component: () => import('./views/bjba/questionnaire/questionnaire-prview.vue'),
          meta: { type: 'menu' },
      },
      {
          path: '/bjba/to_do/info',
          name: 'todo-info',
          component: () => import('./views/bjba/todolist/to_do_info.vue')
      },
      {
        path:'home/phb',
        name:'phb',
        component: () => import('./views/bjba/home/common/phb.vue'),
        meta: { type: 'menu' },
    }
  ],
    beforeEnter:(to:Router,form:Router,next:any) => {
        var token;
        if(!store.getters.token) {
            var info = JSON.parse(sessionStorage.getItem("triman_bsrkapp_store"))

            if(info && info.token) token = info.token
        } else token = store.getters.token
        if (token) {
            if (whiteList.indexOf(to.path) !== -1) {
                // 在免登录白名单，直接进入
                next()
            }
            //是否存在用户信息，没有的话从后端获取
            else if (!store.getters.name) {
                getUserInfo()
                    .then((response: any) => {
                        store.commit('updateUser', response.data)
                        handle()
                    })
                    .catch(error => {
                        store.commit('setToken', '')
                        next('/401')
                        NProgress.done()
                    })
            } else {
                handle()
            }
        } else {
            if (whiteList.indexOf(to.path) !== -1) {
                // 在免登录白名单，直接进入
                next()
            } else {
                next('/login') // 否则全部重定向到登录页
                NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
            }
        }
        //此方法为验证登录成功并获取获取用户信息成功的处理方法
        function handle() {

            if (to.path === '/login') {
                next({ path: '/' })
            } else if (to.path === '/') {
                if (store.getters.user.type === 1) {
                    next('/customer/home')
                    NProgress.done()
                } else {
                    next('/bjba/home')
                    NProgress.done()
                }
            } else {
                // if (hasPermission(to)) {
                //   next()
                // } else {
                //   //不存在权限
                //   next({ path: '/404' })
                //   NProgress.done()
                // }
                if (store.getters.user.type === 1) {
                    next('/customer/home')
                    NProgress.done()
                    return
                }
                next()
            }
        }
}
}
const whiteList = ['/', '/login', '/404', '/401']
const _import = require('./import-' + process.env.NODE_ENV)
// 业务路由配置数组，非后台菜单使用请在此处配置
const routes: any = [
  systemMenus,
  customerMenu,
  businessMenus,
  {
    path: '/login',
    name: 'login',
    component: () => import('./views/login/index.vue')
  },
  {
    path: '/login/initpassword',
    name: 'initpassword',
    component: () => import('./views/login/init-update-password.vue')
  },
    {
        path: '/salary/in',
        name: 'salaryin',
        component: () => import('./views/bjba/asset/salaryin.vue')
    },
    {
        path: '/salary/reversein',
        name: 'reversein',
        component: () => import('./views/bjba/asset/reverse-salaryin.vue')
    },
    {
        path: '/salary/reversehz',
        name: 'reversehz',
        component: () => import('./views/bjba/asset/reverse-hz.vue')
    },
    {
        path: '/salary/reverseschool',
        name: 'reverseschool',
        component: () => import('./views/bjba/asset/reverse-school.vue')
    },
    {
        path: '/salary/gzffreport/view',
        name: 'gzffreport-view',
        component: () => import('./views/bjba/asset/report-view-gzff.vue')
    },
    {
        path: '/salary/gzhzreport/view',
        name: 'gzhzreport-view',
        component: () => import('./views/bjba/asset/report-view-gzhz.vue')
    },
    {
        path: '/salary/gzdreport/view',
        name: 'gzdreport-view',
        component: () => import('./views/bjba/asset/report-view-gzd.vue')
    },
    {
        path: '/salary/gzjsreport/view',
        name: 'gzjsreport-view',
        component: () => import('./views/bjba/asset/report-view-gzjs.vue')
    },
    {
        path: '/salary/zytzreport/view',
        name: 'zytzreport-view',
        component: () => import('./views/bjba/asset/report-view-zytz.vue')
    },

    {
        path: '/salary/hzin',
        name: 'salaryhzin',
        component: () => import('./views/bjba/asset/salaryin-hz.vue')
    },
    {
        path: '/salary/schoolin',
        name: 'salarySchoolIn',
        component: () => import('./views/bjba/asset/salaryin-school.vue')
    },
    {
        path: '/salary/salaryinHistory',
        name: 'schoolinHistory',
        component: () => import('./views/bjba/asset/salaryinHistory.vue')
    },
    {
        path: '/salary/salaryinhzhistory',
        name: 'salaryinhzHistory',
        component: () => import('./views/bjba/asset/salaryinhzhistory.vue')
    },
    {
        path: '/salary/salaryinschoolhistory',
        name: 'salaryinschoolhistory',
        component: () => import('./views/bjba/asset/salaryinschoolhistory.vue')
    },
    {
        path:'/daping/index',
        name:'daping',
        component: () => import('./views/bjba/daping/index.vue'),
    },
  {
    path: '/404',
    name: '404',
    component: () => import('./views/error/404.vue')
  },
  {
    path: '/401',
    name: '401',
    component: () => import('./views/error/401.vue')
  },{
    path: '/xxkk/gssb',
    name: 'gssb',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-gssb.vue')
  },{
    path: '/xxkk/gssbinfo/:sbsj',
    name: 'gssbInfo',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-gssb-info.vue')
  },{
    path: '/xxkk/gssbedit/:sbsj',
    name: 'gssbedit',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-gssb-edit.vue')
  },{
    path: '/xxkk/fzhs',
    name: 'fzhs',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-fzhs.vue')
  },{
    path: '/xxkk/fzhsedit/:sbsj',
    name: 'fzhsedit',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-fzhs-edit.vue')
  },{
    path: '/xxkk/fzhsinfo/:sbsj',
    name: 'fzhsInfo',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-fzhs-info.vue')
  },{
    path: '/xxkk/baqw',
    name: 'baqw',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-baqw.vue')
  },{
    path: '/xxkk/baqwedit/:sbsj',
    name: 'baqwedit',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-baqw-edit.vue')
  },{
    path: '/xxkk/baqwinfo/:sbsj',
    name: 'baqwInfo',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-baqw-info.vue')
  }

  ,{
    path: '/xxkk/qksb',
    name: 'qksb',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-qksb.vue')
  },{
    path: '/xxkk/qksbedit/:sbsj',
    name: 'qksbedit',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-qksb-edit.vue')
  },{
    path: '/xxkk/qksbinfo/:sbsj',
    name: 'qksbInfo',
    component: () => import('./views/bjba/ddkhgl/xxkk/xxkk-qksb-info.vue')
  }
  // ,
  // {
  //   path: '*',
  //   name: '404-2',
  //   component: () => import('./views/error/404.vue')
  // }
]

const router = new Router({
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    },
    isAddDynamicMenuRoutes:false
})
 router.beforeEach((to: Router, from: Router, next: any) => {
    NProgress.start()
    //判断是否存在token，不存在，则未登录
    if (!router.options.isAddDynamicMenuRoutes && (whiteList.indexOf(to.path) == -1)) {
       request({
            url: '/bjba/sys/menu/nav',
            method: 'get'
        }).then(({data}) => {

                fnAddDynamicMenuRoutes(data.data.menus)
                router.options.isAddDynamicMenuRoutes = true
                sessionStorage.setItem('menuList', JSON.stringify(data.data.menus || '[]'))
                sessionStorage.setItem('permissions', JSON.stringify(data.data.permissions || '[]'))
                next({...to, replace: true})



        }).catch((e) => {
            console.log(`%c${e} 请求菜单列表和权限失败，跳转至登录页！！`, 'color:blue')
           sessionStorage.setItem('menuList', JSON.stringify( '[]'))
           sessionStorage.setItem('permissions', JSON.stringify('[]'))
           next({path: '/login'})
        })
    } else{
        next()
    }




})

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
    let temp = []
    for (let i = 0; i < menuList.length; i++) {
        if (menuList[i].children && menuList[i].children.length>= 1) {
            temp = temp.concat(menuList[i].children)
        } else if (menuList[i].url && /\S/.test(menuList[i].url)) {
            menuList[i].url = menuList[i].url.replace(/^\//, '')
            if(menuList[i].openAlone===0) {
                let route = {
                    path: menuList[i].url,
                    component: null,
                    name: menuList[i].url,
                    meta: {
                        menuId: menuList[i].menuId,
                        title: menuList[i].name,
                        keepAlive: menuList[i].keepAlive==1?true:false
                    }
                }
                try {
                    route['component'] = _import(`${menuList[i].component}`) || null;
                    // route['component']= import(`./views/${menuList[i].component}.vue`)
                } catch (e) {
                    console.log(e)
                }
                routes.push(route)
            }

        }
    }
    if (temp.length >= 1) {
        fnAddDynamicMenuRoutes(temp, routes)
    } else {
        businessMenus.name='main-dynamic'
        businessMenus.children = routes
        router.addRoutes([
            businessMenus,
            {path: '*', redirect: {name: '404'}}
        ])
        sessionStorage.setItem('dynamicMenuRoutes', JSON.stringify(businessMenus.children || '[]'))
    }
}
router.afterEach(() => {
    NProgress.done() // finish progress bar
})

export default router
